var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconBulb = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M15,3c-4.5-0.1-8.2,3.4-8.4,7.8c0,2.6,1.4,5,3.6,6.4v2.5\n\tc0,0.6,0.6,1.1,1.2,1.1h7.2c0.6,0,1.2-0.5,1.2-1.1v-2.5c2.2-1.4,3.6-3.8,3.6-6.4C23.2,6.4,19.5,2.9,15,3L15,3z" }),
            React.createElement("line", { x1: "12.6", y1: "27", x2: "17.6", y2: "27" }),
            React.createElement("line", { x1: "11.6", y1: "24", x2: "18.6", y2: "24" }))));
});
export default IconBulb;
//# sourceMappingURL=IconBulb.js.map